import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Translation from '../../../v2/lang/Translation';

export function DeliveryOptionDateRange(props) {
  if (!props.endDate && !props.startDate) return null;
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);
  
  const startDate = new Date(props.startDate);
  startDate.setHours(0, 0, 0, 0);
  
  const endDate = new Date(props.endDate);
  endDate.setHours(0, 0, 0, 0);
  
  const startDay = startDate.toLocaleString(props.locale, {weekday: 'long'});
  const startDayOfMonth = startDate.toLocaleString(props.locale, {day: 'numeric'});
  const startDayMonth = startDate.toLocaleString(props.locale, {month: 'long'});
  
  const endDay = endDate.toLocaleString(props.locale, {weekday: 'long'});
  const endDayOfMonth = endDate.toLocaleString(props.locale, {day: 'numeric'});
  const endDayMonth = endDate.toLocaleString(props.locale, {month: 'long'});
  
  const startDayLongText = `${startDay} ${startDayOfMonth} ${startDayMonth}`;
  const startDayShortText = `${startDayMonth} ${startDayOfMonth}`;
  
  const endDayTextLong = `${endDay} ${endDayOfMonth} ${endDayMonth}`;
  const endDayShortText = `${endDayMonth} ${endDayOfMonth}`;
  
  const isGuaranteedDay = (startDate.getTime() === endDate.getTime());
  
  const onlyStartDate = props.startDate && !props.endDate;
  const onlyEndDate = props.endDate && !props.startDate;
  
  const getDateTranslation = () => {
    if (isGuaranteedDay) {
      // Delivered on Thursday 2 January
      return (
        <Translation
          placeholderValues={[startDayLongText]}
          optionalExtension={props.deliveryOptionType}
        >
          messages.deliveryOptions.dateRange.on
        </Translation>
      );
    }
    
    if (onlyStartDate) {
      // Delivered after Wednesday 13 January
      return (
        <Translation
          placeholderValues={[startDayLongText]}
          optionalExtension={props.deliveryOptionType}
        >
          messages.deliveryOptions.dateRange.after
        </Translation>
      );
    }
    
    if (onlyEndDate) {
      // Delivered by Wednesday 13 January
      return (
        <Translation
          placeholderValues={[endDayTextLong]}
          optionalExtension={props.deliveryOptionType}
        >
          messages.deliveryOptions.dateRange.by
        </Translation>
      );
    }
    
    const endDateText = (startDayMonth === endDayMonth) ? `${endDayOfMonth}` : endDayShortText;
    // Delivered between January 13 - December 14 or January 13 - 15
    return (
      <Translation
        placeholderValues={[startDayShortText, endDateText]}
        optionalExtension={props.deliveryOptionType}
      >
        messages.deliveryOptions.dateRange.between
      </Translation>
    );
  };
  
  return (
    <div data-test="DeliveryOptionDateRange">
      {getDateTranslation()}
    </div>
  );
}

DeliveryOptionDateRange.propTypes = {
  locale: PropTypes.string.isRequired,
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  deliveryOptionType: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  locale: state.start.siteDataV2.locale.replace('_', '-').toLowerCase(),
});

export default connect(mapStateToProps)(DeliveryOptionDateRange);
